import { yupResolver } from '@hookform/resolvers/yup';

const CreateFormResolver = (schema) => {
  const resolver = yupResolver(schema);
  resolver.schema = schema;
  return resolver;
};

export const CreateDynamicFormResolver = ({ schemaFactory, getContext = () => ({}) }) => {
  const resolver = async (values, context, options) => {
    const schema = schemaFactory();

    return yupResolver(schema)(values, getContext(), options);
  };

  resolver.schemaFactory = schemaFactory;
  resolver.getContext = getContext;

  return resolver;
};

export default CreateFormResolver;
